import BaseModel from '../core/BaseModel'
export default class HistoryPaymentModel extends BaseModel {
    constructor() {
        super({
            tableName: 'history_payment', label: " Lịch Sử Kích Hoạt Gói", display_key: 'name',name: "history_payment",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            username: {
              name: "username",
              type: "String",
              label: "Username",
              filter: { type: "input", match: "contains" },
            },
            name: {
                name: "name",
                type: "String",
                label: "Tên gói",
                filter: { type: "input", match: "contains" },
            },
            value: {
              name: "value",
              type: "String",
              label: "Thời hạn gói",
              class: "center",
              filter: { type: "input", match: "contains" },
            },
            expiration_date: {
              name: "expiration_date",
              type: "Datetime",
              label: "Sau kích hoạt",
              filter: { type: 'DateRange', match: 'contains'},
            },
            fee: {
              name: "fee",
              type: "Number",
              label: "Phí (đ)",
              class: "right",
            },
            type: {
              name: "type",
              type: "Selection",
              label: "Loại",
              options: [
                { value: "ADMIN", label: 'Admin thao tác'},
                { value: "ONLINE", label: 'Online'}
              ],
              filter: {
                type: 'select',
                optionLabel: 'label',
                optionKey: 'value',
                match: 'equals'
              }
            },
            type_payment: {
                name: "type_payment",
                label: "PTTT",
                type: "Selection",
                options: [
                  { value: "TRANSFER", label: 'Chuyển khoản công ty'}
                ],
                filter: {
                  type: 'select',
                  optionLabel: 'label',
                  optionKey: 'value',
                  match: 'equals'
                },
            },
            created_by: {
                refs:"created_by",
                type: "String",
                label: "Người tạo"
            },
            created_at : {
              name: 'created_at',
              type: "Datetime",
              label: 'Ngày tạo',
            },
        })
    }

}